// extracted by mini-css-extract-plugin
export default {"page":"mY-z","cartModal":"nY-z","checkout":"oY-z","placeholder":"pY-z","account":"qY-z"};